
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiArrowDownGoogle as ObiArrowDownGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-arrow-down-google.js';
 
 
 

 
 export const ObiArrowDownGoogle = createComponent({
   react: React,
   tagName: 'obi-arrow-down-google',
   elementClass: ObiArrowDownGoogleElement,
   events: {
     
   }
  });
 
 